import * as React from 'react';
import { useForm } from 'react-hook-form';
import Avatar from '@mui/material/Avatar';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import { MdLockOutline, MdOutlinePersonAddAlt } from "react-icons/md";
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { CircularProgress, IconButton, InputAdornment, Modal, Stack } from '@mui/material';
import RtlProvider from '../Components/RtlProvider';
import { ContextNotification, severitys } from '../App';
import { useNavigate } from 'react-router-dom';
import { loadCaptchaEnginge, LoadCanvasTemplate, validateCaptcha } from 'react-simple-captcha';
import logo from "../assets/logo.png"
import UserApi from '../api/UserApi';
import helper from '../helper';
import enumMapper from '../enumMapper';
import CustomLink from '../Components/CustomLink';
import { VscEye, VscEyeClosed } from 'react-icons/vsc';

import Header from './Header';
import themes from '../themes';

const RegisterGuest = () => {
    const { open, setOpen } = React.useContext(ContextNotification);
    const schema = yup.object().shape({
        firstName: yup.string().required("نام را وارد نمایید"),
        lastName: yup.string().required("نام خانوادگی را وارد نمایید"),
        username: yup.string().required("نام کاربری (شماره گذرنامه) را وارد نمایید").max(10, 'حداکثر 10 کاراکتر وارد نمایید'),
        password: yup.string().required("رمز عبور را وارد نمایید").min(8, 'حداقل 8 کاراکتر وارد نمایید'),
        repassword: yup.string().required("تکرار رمز عبور را وارد نمایید").oneOf([yup.ref('password'), null], 'رمز عبور با تکرار آن متفاوت است'),
        captchaValue: yup.string().trim().required("متن تصویر فوق را وارد نمایید")
    });


    const { register, formState: { errors }, handleSubmit } = useForm({
        resolver: yupResolver(schema),
    });
    const [loading, setLoading] = React.useState(false);
    const [showPassword, setShowPassword] = React.useState(false);

    const navigate = useNavigate();
    React.useEffect(() => {
        loadCaptchaEnginge(4, '#E9ECE0', '#A800B8', 'numbers');
        // handleloggedIn();
    }, []);

    const handleClickShowPassword = () => setShowPassword((show) => !show);
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };
    const handleMouseUpPassword = (event) => {
        event.preventDefault();
    };
    const handleloggedIn = () => {
        var Token = localStorage.getItem("token") ?? null;
        if (Token) navigate("/dashboard/Home");

    }


    const onSubmit = (data) => {
        if (SubmitCaptcha(data.captchaValue))
            submitUser(data.firstName, data.lastName, null, null, data.username, data.password, data.repassword);
    };
    function SubmitCaptcha(captchavalue) {
        if (validateCaptcha(captchavalue) === true) {
            return true;
        }
        else {
            setOpen({ IsEnable: true, Message: 'متن تصویر نادرست است', severity: severitys.error });
            loadCaptchaEnginge(4, '#E9ECE0', '#A800B8', 'numbers');
            return false
        }
    };
    const submitUser = (firstName, lastName, brokerNo, mobile, username, password, repassword) => {
        setLoading(true);
        return (
            UserApi.RegisterGuest(firstName, lastName, brokerNo, mobile, username, password, repassword)
                .then((res) => {
                    UserApi.Login(username, password, enumMapper.AppId.GuestService)
                        .then((res) => {
                            localStorage.setItem("token", res.data.access_token);
                            window.location.pathname = "/Dashboard/Home";
                        })
                        .catch(err => {
                            setLoading(false)
                            setOpen({ IsEnable: true, Message: 'نام کاربری یا رمز عبور نادرست است', severity: severitys.error });
                            loadCaptchaEnginge(4, '#E9ECE0', '#A800B8', 'numbers');
                        }).finally(() => { })
                })
                .catch(err => {
                    setLoading(false)
                    var errmsg = '';
                    if (err.response && err.response.data && err.response.data[0] && err.response.data[0].code) {
                        var code = err.response.data[0].code;
                        errmsg = helper.renderErrorMessage(code);

                    }

                    if (err.response && err.response.data) {

                        setOpen({ IsEnable: true, Message: (errmsg !== '') ? errmsg : JSON.stringify(err.response.data), severity: severitys.error });
                    }
                    else if (err.response && err.response.data.errors) {

                        setOpen({ IsEnable: true, Message: (errmsg !== '') ? errmsg : JSON.stringify(err.response.data.errors), severity: severitys.error });
                    }
                    else if (err.message) {
                        setOpen({ IsEnable: true, Message: (errmsg !== '') ? errmsg : JSON.stringify(err.message), severity: severitys.error });
                    }
                    else
                        console.log(err)
                    loadCaptchaEnginge(4, '#E9ECE0', '#A800B8', 'lower');


                }).finally(() => { })
        );
    }

    return (
        <ThemeProvider theme={themes.defaultTheme}>
            <Box sx={{ minHeight: "100vh", bgcolor: "white" }}>
                {/* Header */}
                <Header visible={true} title={"ورود"} href={"/login"} />

                {/* Main login form */}
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        px: { xs: 2, sm: 3 },
                        py: { xs: 4, sm: 6 },
                    }}
                >
                    {/* Flat login container */}
                    <Box
                        sx={{
                            width: "100%",
                            maxWidth: 360,
                            px: 3,
                            py: 4,
                            bgcolor: "white",
                            borderRadius: 0.5, // minimal radius
                            border: "1.5px solid #0c3353", // visible border
                            boxShadow: "0 1px 2px rgba(0,0,0,0.05)", // very subtle shadow
                        }}
                    >
                        <Stack spacing={3}>
                            <Typography
                               variant="myTitle"
              textAlign="center"
              fontWeight={700}
              color="black"
              fontSize={20}
                            >
                                ثبت نام
                            </Typography>
                            <RtlProvider>
                                <Box component="form" onSubmit={handleSubmit(onSubmit)} sx={{ mt: 1 }} autoComplete="off">
                                    <TextField
                                        fullWidth
                                        label="نام"
                                        {...register("firstName")}
                                        error={!!errors.firstName?.message}
                                        helperText={errors.firstName?.message}
                                        sx={{ mb: 1 }}
                                    />
                                    {/* <p className="error">{errors.firstName?.message}</p> */}
                                    <TextField
                                        fullWidth
                                        label="نام خانوادگی"
                                        {...register("lastName")}
                                        error={!!errors.lastName?.message}
                                        helperText={errors.lastName?.message}
                                        sx={{ mb: 1 }}
                                    />
                                    {/* <p className="error">{errors.lastName?.message}</p> */}
                                    <TextField
                                        fullWidth
                                        label="نام کاربری (شماره گذرنامه)"
                                        {...register("username")}
                                        error={!!errors.username?.message}
                                        helperText={errors.username?.message}
                                        sx={{ mb: 1 }}
                                    />
                                    {/* <p className="error">{errors.username?.message}</p> */}
                                    <TextField
                                        fullWidth
                                        label="رمز عبور"
                                        type={showPassword ? 'text' : 'password'}
                                        {...register("password")}
                                        autoComplete="new-password"
                                        InputProps={{
                                            endAdornment: <InputAdornment position="start"><IconButton
                                                aria-label={
                                                    showPassword ? 'hide the password' : 'display the password'
                                                }
                                                onClick={handleClickShowPassword}
                                                onMouseDown={handleMouseDownPassword}
                                                onMouseUp={handleMouseUpPassword}
                                                edge="end"
                                            >
                                                {showPassword ? <VscEye /> : <VscEyeClosed />}
                                            </IconButton></InputAdornment>,
                                        }}
                                        error={!!errors.password?.message}
                                        helperText={errors.password?.message}
                                        sx={{ mb: 1 }}
                                    />
                                    {/* <p className="error">{errors.password?.message}</p> */}
                                    <TextField
                                        fullWidth
                                        label="تکرار رمز عبور"
                                        type={showPassword ? 'text' : 'password'}
                                        {...register("repassword")}
                                        InputProps={{
                                            endAdornment: <InputAdornment position="start"><IconButton
                                                aria-label={
                                                    showPassword ? 'hide the password' : 'display the password'
                                                }
                                                onClick={handleClickShowPassword}
                                                onMouseDown={handleMouseDownPassword}
                                                onMouseUp={handleMouseUpPassword}
                                                edge="end"
                                            >
                                                {showPassword ? <VscEye /> : <VscEyeClosed />}
                                            </IconButton></InputAdornment>,
                                        }}
                                        error={!!errors.repassword?.message}
                                        helperText={errors.repassword?.message}
                                        sx={{ mb: 1 }}
                                    />
                                    {/* <p className="error">{errors.repassword?.message}</p> */}
                                    <div>
                                        <div style={{ fontSize: '12px', textAlign: 'center' }}> <LoadCanvasTemplate reloadText="بارگذاری مجدد" reloadColor="blue" /></div>
                                        <TextField
                                            margin="normal"
                                            fullWidth
                                            label="متن تصویر فوق را وارد کنید"
                                            {...register("captchaValue")}
                                            error={!!errors.captchaValue?.message}
                                            helperText={errors.captchaValue?.message}
                                        />
                                        {/* <p className="error">{errors.captchaValue?.message}</p> */}
                                    </div>
                                    <Button
                                        disabled={loading}
                                        type="submit"
                                       fullWidth
                                        variant="contained"
                                        color='primary'
                                        sx={{ mt: 3, mb: 2 }}
                                    >
                                        <Typography sx={{ display: "flex", alignItems: "center" }}>
                                            ثبت نام                                    {loading && <CircularProgress color="inherit" size="20px" sx={{ mx: '0.5rem' }} />}
                                        </Typography>
                                    </Button>
                                </Box>
                            </RtlProvider>
                        </Stack>
                    </Box>
                </Box>
            </Box>
        </ThemeProvider>

    );
}
export default RegisterGuest;